@let configs = this.configs();
@if (configs.length > 0) {
  <div
    class="fixed z-[999] top-0 left-0 w-full h-full"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()"
  >
    <div
      class="modal-overlay"
      (click)="$event.stopPropagation(); service.dismiss(activeConfig()?.id ?? '')"
      (keydown)="$event.stopPropagation()"
      (keyup)="$event.stopPropagation()"
    ></div>
    @for (config of configs; track config.id) {
      <soft-modal
        class="z-[1000] relative"
        [config]="config"
        [active]="config === activeConfig()"
        [style.display]="config === activeConfig() ? 'block' : 'none'"
      ></soft-modal>
    }
  </div>
}
